import { FileOpenOutlined } from '@mui/icons-material';
import { ListItemIcon } from '@mui/material';
import { CuriosityNamespaceType, CuriosityValue } from '@procureai/curiosity-ui-mui';
import clsx from 'clsx';

import { DocumentListItemText } from '../../DocumentListItem/DocumentListItemText';
import {
  documentListItemclasses as classes,
  ListItemStyled,
} from '~/modules/demand/DemandDocumentWidget/components/DemandDocumentForm/components/DocumentListItem.styled';
import { DocumentListItemSecondaryActions } from '~/modules/demand/DemandDocumentWidget/components/DemandDocumentForm/components/DocumentListItemSecondaryActions';

export interface DocumentListItemProps {
  index: number;
  isMarkedForDeletion: boolean;
  file: {
    fileId: string;
    isSharedWithSupplier?: boolean;
    quoteId?: string | null;
    hasNegotiationCase: boolean;
  };
}

export const DocumentListItem = ({ file, index, isMarkedForDeletion }: DocumentListItemProps) => {
  return (
    <ListItemStyled
      disablePadding
      key={file.fileId}
      className={clsx({ [classes.opacityDelete]: isMarkedForDeletion })}
      secondaryAction={
        <DocumentListItemSecondaryActions
          index={index}
          hasNegotiationCase={file.hasNegotiationCase}
          isMarkedForDeletion={isMarkedForDeletion}
        />
      }
    >
      <ListItemIcon>
        <FileOpenOutlined />
      </ListItemIcon>
      <DocumentListItemText primary={<CuriosityValue ns={CuriosityNamespaceType.FILE} i18nKey={file.fileId} />} />
    </ListItemStyled>
  );
};
